import { createUseStyles } from "react-jss";
//import { apaTheme } from "../../constants/theme";

export const useStyles = () => {
  return createUseStyles({
    container: {
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      alignItems: "center",
      width: "100%",
      boxSizing: "border-box",
    },
    label: {
      color: "#6B6B6C",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "18px",
      whiteSpace: "nowrap", // Prevents text from wrapping to the next line
    },
    line: {
      backgroundColor: "#CAC4D0",
      height: "1px",
      width: "100%",
    },
  })();
};
